import api from '@/store/api';
import { athena, boro } from '@/store/api/instances';
import type { TaskType } from '@/types/serviceTicket';
import type { ApiListingRequest, ApiResponse } from '@bitstopco/bitstop-theme';

interface CreateTaskTypeRequest {
  name: string;
  description: string;
}

interface UpdateTaskTypeRequest {
  id: string;
  name: string;
  description: string;
  is_active?: boolean;
}

/**
 * RTK Query API for Task Types.
 */
export const taskTypesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTaskTypes: build.query<ApiResponse<TaskType[]>, ApiListingRequest | void>({
      query: (data) =>
        athena({
          url: 'v2/operations/task-types',
          method: 'POST',
          data: data || {
            pagination: {
              current_page: 1,
              items_per_page: 1000,
              sort_by: 'name',
              sort_ascending: true,
            },
          },
        }),
      providesTags: ['TaskTypes'],
    }),
    createTaskType: build.mutation<ApiResponse<TaskType>, CreateTaskTypeRequest>({
      query: (data) =>
        boro({
          url: 'v2/operations/service-tickets/task-types',
          method: 'POST',
          data,
        }),
      invalidatesTags: ['TaskTypes'],
    }),
    updateTaskType: build.mutation<ApiResponse<TaskType>, UpdateTaskTypeRequest>({
      query: ({ id, ...data }) =>
        boro({
          url: `v2/operations/service-tickets/task-types/${id}`,
          method: 'PATCH',
          data,
        }),
      invalidatesTags: ['TaskTypes'],
    }),
    deleteTaskType: build.mutation<void, string>({
      query: (id) =>
        boro({
          url: `v2/operations/service-tickets/task-types/${id}`,
          method: 'DELETE',
        }),
      invalidatesTags: ['TaskTypes'],
    }),
  }),
});

export const {
  useGetTaskTypesQuery,
  useCreateTaskTypeMutation,
  useUpdateTaskTypeMutation,
  useDeleteTaskTypeMutation,
} = taskTypesApi;
